module.exports = __webpack_public_path__ + "img/paid-coupon-active.3ba97202.svg";